import { render, staticRenderFns } from "./UndueHardshipFS.vue?vue&type=template&id=684bcad1&scoped=true"
import script from "./UndueHardshipFS.vue?vue&type=script&lang=ts"
export * from "./UndueHardshipFS.vue?vue&type=script&lang=ts"
import style0 from "./UndueHardshipFS.vue?vue&type=style&index=0&id=684bcad1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bcad1",
  null
  
)

export default component.exports